'use client';
import { OnbModal } from '@/components/modal';
import { DevPanel } from '@/devTools/devPanel';
import { CssBaseline, ThemeProvider } from '@mui/material';
import { FloatingWhatsApp, OfflineBanner, ReduxToast, RenderWhenIdle, theme } from '@repo/ui';
import { sendEventProps, SendNavigatorData } from '@repo/utils';
import { useEffect, useState } from 'react';
import { Provider } from 'react-redux';
import { hideToast } from './navigationSlice';
import { makeStore, RootState } from './store';

// devTools: whether the layout found this browser unlocked for the dev tools
export function Providers({ children, devTools }: { children: React.ReactNode; devTools: boolean }) {
  const [store] = useState(makeStore);
  useEffect(() => {
    SendNavigatorData({
      app: 'onboarding',
      instanceType: process.env.NEXT_PUBLIC_ONB_INSTANCE_TYPE as sendEventProps['instanceType'],
    });
  }, []);
  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <OfflineBanner />
      <Provider store={store}>
        <OnbModal />
        <ReduxToast selectToast={(state: RootState) => state.navigationdata.toastData} hideToast={hideToast} />
        {children}
        {/* Inside the Redux provider: it reads the current step and fills its variables */}
        {devTools && <DevPanel />}
        {/* Mounted once the browser is idle: keeps the chat button out of hydration */}
        <RenderWhenIdle>
          {process.env.NEXT_PUBLIC_ONB_INSTANCE_TYPE === 'onb-comercios' && (
            <FloatingWhatsApp
              enable
              buttonTitle="¿Tenés dudas?"
              buttonSubtitle="Atención a comercios​"
              phoneNumber="5491157494024"
            />
          )}
          {process.env.NEXT_PUBLIC_ONB_INSTANCE_TYPE === 'onb-efectivo' && <FloatingWhatsApp enable />}
        </RenderWhenIdle>
      </Provider>
    </ThemeProvider>
  );
}
